<template>
  <el-dialog
    width="500px"
    class="ConfirmDialogCom"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :show-close="false">
    <div slot="title" class="dialogTitle">
      <span>操作确认</span>
    </div>
    <div class="ConfirmDialogCom_con u-textCenter">
      <p v-if="fatherData.title">{{fatherData.title}}</p>
      <p v-else>确认删除吗？</p>
      <p class="tips" v-if="fatherData.tips">（{{fatherData.tips}}）</p>
    </div>
    
    <div slot="footer" class="ConfirmDialogCom">
      <template>
        <el-button type="primary" @click="onSubmit">确定</el-button>
        <el-button @click="onCancle">取消</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'ConfirmDialogCom',
    props: {
      fatherData: Object
    },
    data () {
      return {
        visible: false,
        timmer: null
      };
    },
    watch: {
      visible (val, oldVal) {
        if (val) {
        
        } else {
        
        }
      }
    },
    methods: {
      onSubmit () {
        if (this.timmer) {
          clearTimeout(this.timmer);
        }
        
        // 只执行一次
        this.timmer = setTimeout(() => {
          this.$emit('onConfirmSubmit', this.onCancle);
        }, 600);
      },
      
      onCancle () {
        this.visible = false;
        this.timmer = null;
      }
    }
  };
</script>

<style lang="scss">
  .ConfirmDialogCom_con {
    p {
      line-height: 40px;
    }
    
    .tips {
      color: #A9A9A9;
    }
  }
</style>
